import { useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { DocumentPanel } from "./DocumentPanel";
import { RelatedDocs } from "./RelatedDocs";

// Collapsible "All fields" section embedded in each section's detail drawer.
// related: [{ label, path, filters, describe }]; extraDocs: [{ label, path, id }]
export function AllFieldsPanel({ path, id, related = [], extraDocs = [] }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="mt-6 rounded-lg border border-border" data-testid="all-fields-panel">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-3 py-2.5 hover:bg-accent/40 transition-colors" data-testid="all-fields-toggle">
        <span className="font-heading font-semibold text-sm text-foreground flex items-center gap-2"><Icons.Database className="h-4 w-4 text-primary" /> All fields · Firestore</span>
        <Icons.ChevronDown className={`h-4 w-4 text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-3 pb-3">
          <Link to={`/data?path=${encodeURIComponent(path)}&doc=${encodeURIComponent(id)}`} className="text-[11px] text-primary hover:underline inline-flex items-center gap-1 mb-2" data-testid="all-fields-open-explorer">
            <Icons.ExternalLink className="h-3 w-3" /> {path}/{id} in Data Explorer
          </Link>
          <DocumentPanel path={path} id={id} />
          {extraDocs.map((x) => (
            <div key={`${x.path}/${x.id}`} className="mt-4" data-testid={`extra-doc-${x.id}`}>
              <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground mb-2">{x.label} · {x.path}/{x.id}</p>
              <DocumentPanel path={x.path} id={x.id} />
            </div>
          ))}
          {related.map((r) => <RelatedDocs key={r.path + r.label} {...r} />)}
        </div>
      )}
    </div>
  );
}
